import type { AgentTaskDetailResponse, AgentTaskStatisticsResponse, CommonResponse, CreateAgentTaskRequest, CreateAgentTaskResponse, DeleteAgentTaskResponse, DifyCallbackReportResponse, MyTasksRequest, MyTasksResponse, ResetAgentTaskRequest, TaskExecutionsRequest, TaskExecutionsResponse, TaskExecutionsGroupResponse } from './types';
import { del, get, post, put } from '@/utils/request';

// 任务相关API
export const taskApi = {
  // 获取任务列表（使用后端接口）
  getTaskList: (params?: {
    page?: number;
    pageSize?: number;
    status?: string;
  }) => {
    return get<any>('/system/agentTask/myTasks', params).json();
  },

  // 根据ID获取任务详情
  getTaskById: (id: string) => {
    return get<AgentTaskDetailResponse>(`/system/agentTask/detail/${id}`).json();
  },

  // 创建任务（使用后端接口）
  createTask: (data: any) => {
    return post<any>('/system/agentTask', data).json();
  },

  // 更新任务（使用后端接口）
  updateTask: (id: string, data: any) => {
    return put<any>(`/system/agentTask/${id}`, data).json();
  },

  // 获取任务执行记录（后端接口）
  getTaskExecutions: async (taskId: string | number, params?: TaskExecutionsRequest) => {
    try {
      const mergedParams: TaskExecutionsRequest = {
        // 默认按时间倒序
        isAsc: 'asc',
        ...params,
      };
      const response = await get<TaskExecutionsResponse>(`/system/agentTaskExecution/listByTaskId/${taskId}`, mergedParams).json();
      return response;
    }
    catch (error) {
      console.log('获取任务执行记录失败:', error);
      return {
        code: 200,
        msg: 'success',
        rows: [],
        total: 0,
      };
    }
  },

  // 获取任务执行记录（分组版本，新接口）
  getTaskExecutionsWithGroup: async (taskId: string | number, params?: TaskExecutionsRequest) => {
    try {
      const mergedParams: TaskExecutionsRequest = {
        // 默认按时间倒序
        isAsc: 'asc',
        ...params,
      };
      const response = await get<TaskExecutionsGroupResponse>(`/system/agentTaskExecution/listByTaskIdWithGroup/${taskId}`, mergedParams).json();
      return response;
    }
    catch (error) {
      console.log('获取任务执行记录（分组）失败:', error);
      return {
        code: 200,
        msg: 'success',
        rows: [],
        total: 0,
      };
    }
  },

  // 删除执行记录
  deleteExecution: (id: string) => {
    return del<any>(`/api/task-executions/${id}`).json();
  },

  // 我的任务列表（后端接口）
  myTasks: (params?: MyTasksRequest) => {
    return get<MyTasksResponse>('/system/agentTask/myTasks', params).json();
  },

  // 自动化页顶部统计
  getTaskStatistics: () => {
    return get<AgentTaskStatisticsResponse>('/system/agentTask/statistics').json();
  },

  // 创建智能体任务（后端接口）
  createAgentTask: (data: CreateAgentTaskRequest) => {
    return post<CreateAgentTaskResponse>('/system/agentTask', data).json();
  },

  // 启动智能体任务（后端接口）
  startAgentTask: (id: string | number) => {
    return put<any>(`/system/agentTask/start/${id}`).json();
  },

  // 暂停智能体任务（后端接口）
  pauseAgentTask: (id: string | number) => {
    return put<any>(`/system/agentTask/pause/${id}`).json();
  },

  // 停止智能体任务（后端接口）
  stopAgentTask: (id: string | number) => {
    return put<any>(`/system/agentTask/stop/${id}`).json();
  },

  // 重置智能体任务（后端接口）
  // 说明：按需传入需要重置的字段，例如 { id, startTime, endTime, maxRunCount, repeatInterval, repeatUnit, runCycle }
  resetAgentTask: (data: ResetAgentTaskRequest) => {
    return put<CommonResponse>('/system/agentTask', data).json();
  },

  // 删除智能体任务（后端接口）
  deleteAgentTask: (id: string | number) => {
    return del<DeleteAgentTaskResponse>(`/system/agentTask/${id}`).json();
  },

  // 获取任务执行结果标签列表（后端接口）
  getTaskExecutionTags: (taskId: string | number) => {
    return get<CommonResponse<string[]>>(`/system/agentTaskExecution/tags/${taskId}`).json();
  },

  // 获取执行报告内容（后端接口）
  getReportContent: (reportId: string | number) => {
    return get<DifyCallbackReportResponse>(`/api/dify/callback/report/${reportId}`).json();
  },
};
